/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svtag_MeshInputs */

const en_svtag_mesh = /** @type {(inputs: Svtag_MeshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MESH`)
};

const ar_svtag_mesh = /** @type {(inputs: Svtag_MeshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#شبكة`)
};

const bn_svtag_mesh = /** @type {(inputs: Svtag_MeshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MESH`)
};

const de_svtag_mesh = /** @type {(inputs: Svtag_MeshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MESH`)
};

const es_svtag_mesh = /** @type {(inputs: Svtag_MeshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MESH`)
};

const fr_svtag_mesh = /** @type {(inputs: Svtag_MeshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MESH`)
};

const pt_svtag_mesh = /** @type {(inputs: Svtag_MeshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MESH`)
};

const zh_svtag_mesh = /** @type {(inputs: Svtag_MeshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MESH`)
};

const tr_svtag_mesh = /** @type {(inputs: Svtag_MeshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MESH`)
};

const ru_svtag_mesh = /** @type {(inputs: Svtag_MeshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MESH`)
};

const pl_svtag_mesh = /** @type {(inputs: Svtag_MeshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`#MESH`)
};

/**
* | output |
* | --- |
* | "#MESH" |
*
* @param {Svtag_MeshInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svtag_mesh = /** @type {((inputs?: Svtag_MeshInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svtag_MeshInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svtag_mesh(inputs)
	if (locale === "bn") return bn_svtag_mesh(inputs)
	if (locale === "de") return de_svtag_mesh(inputs)
	if (locale === "es") return es_svtag_mesh(inputs)
	if (locale === "fr") return fr_svtag_mesh(inputs)
	if (locale === "pt") return pt_svtag_mesh(inputs)
	if (locale === "zh") return zh_svtag_mesh(inputs)
	if (locale === "tr") return tr_svtag_mesh(inputs)
	if (locale === "ru") return ru_svtag_mesh(inputs)
	if (locale === "pl") return pl_svtag_mesh(inputs)
	return en_svtag_mesh(inputs)
});